import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'apps/piqet-angular/src/environments/environment';
import { AnyARecord } from 'dns';
import { CookieService } from 'ngx-cookie-service';
import { SharedService } from '../shared/shared.service';

@Injectable({
  providedIn: 'root',
})
export class ProjectsService {
  apiUrl = environment.url;

  constructor(
    private http: HttpClient,
    private cookieService: CookieService,
    private sharedService: SharedService
  ) {}

  getMyAllProjectList() {
    return this.http.get<any>(`${this.apiUrl}/Project/GetAllProjects`);
  }

  getMyAllProjectListAdmin() {
    return this.http.get<any>(`${this.apiUrl}/Project/GetAllProjectsAdmin`);
  }

  getMyAllProductProjectList() {
    return this.http.get<any>(`${this.apiUrl}/ProductConfiguration/GetAllProductConfigurationList`);
  }
  GetAllProductContentListAdmin() {
    return this.http.get<any>(
      `${this.apiUrl}/ProductConfiguration/GetAllProductConfigurationListAdmin`
    );
  }

  deleteMyAllProjectList(projectId: any) {
    return this.http.delete<any>(`${this.apiUrl}/Project/DeleteProject?projectId=${projectId}`);
  }
  UpdateProjectVisibility(projectId: any, isVisible: boolean) {
    return this.http.get<any>(
      `${this.apiUrl}/Project/UpdateProjectVisibility?projectId=${projectId}&isVisible=${isVisible}`
    );
  }
  UpdateProductVisibility(productId: any, isVisible: boolean) {
    return this.http.get<any>(
      `${this.apiUrl}/ProductContent/UpdateProductVisibility?productId=${productId}&isVisible=${isVisible}`
    );
  }

  getMyAllProjectModalData(projectId: any) {
    return this.http
      .get<any>(`${this.apiUrl}/Project/GetProjectForAddUpdate?projectId=${projectId}`)
      .toPromise();
  }

  getMyAllProductProjectModalEditData(
    productConfigId: any,
    isAddProduct?: boolean,
    productId?: any
  ) {
    const payload = {
      productConfigId: Number(productConfigId),
      isAddProduct: isAddProduct,
      productId: Number(productId),
    };
    return this.http
      .post<any>(
        `${this.apiUrl}/ProductConfiguration/GetProductConfigurationDataforAddUpdate`,
        payload
      )
      .toPromise();
  }

  getMyAllProductProjectModalData(productId: any) {
    return this.http.get<any>(
      `${this.apiUrl}/ProductContent/GetProductContentForAddUpdate?productId=${productId}`
    );
  }

  getMyAllProjectModalDataForCopy(projectId: any) {
    return this.http
      .get<any>(`${this.apiUrl}/Project/GetProjectForCopy?projectId=${projectId}`)
      .toPromise();
  }

  addEditMyAllProjectData(payload: any) {
    return this.http.post<any>(`${this.apiUrl}/Project/AddUpdateProject`, payload);
  }

  copyMyAllProjectData(payload: any) {
    return this.http.post<any>(`${this.apiUrl}/Project/SaveCopiedProject`, payload);
  }

  getMyAllProjectModalDataForProjectDetails(projectId: any) {
    return this.http
      .get<any>(`${this.apiUrl}/Project/GetProjectForAddUpdate?projectId=${projectId}`)
      .toPromise();
  }

  getMyAllProjectScenarioList(projectId: any, scenarioTypeId: any) {
    return this.http
      .get<any>(
        `${this.apiUrl}/Scenario/GetAllProjectScenarioListByType?projectId=${projectId}&scenarioTypeId=${scenarioTypeId}`
      )
      .toPromise();
  }
  getProductContentBYProductConfigId(productConfigId: any) {
    return this.http
      .get<any>(
        `${this.apiUrl}/ProductContent/GetProductContentBYProductConfigId?productConfigId=${productConfigId}`
      )
      .toPromise();
  }

  getMyAllProjectScenarioModalData(projectId: any, scenarioTypeId: any, scenarioId: any) {
    return this.http.get<any>(
      `${this.apiUrl}/Scenario/GetScenarioForAddUpdate?projectId=${projectId}&scenarioTypeId=${scenarioTypeId}&scenarioId=${scenarioId}`
    );
  }

  getMyAllProjectScenarioModalDataAsync(projectId: any, scenarioTypeId: any, scenarioId: any) {
    // ASYNC for scenario modal
    return this.http
      .get<any>(
        `${this.apiUrl}/Scenario/GetScenarioForAddUpdate?projectId=${projectId}&scenarioTypeId=${scenarioTypeId}&scenarioId=${scenarioId}`
      )
      .toPromise();
  }

  getMyAllProjectScenarioWholesaleList(storagetypeId: any, scenarioId: any, projectId: any) {
    return this.http.get<any>(
      `${this.apiUrl}/Storage/GetAllStorageListByTypeAndScenarioId?storagetypeId=${storagetypeId}&scenarioId=${scenarioId}&projectId=${projectId}`
    );
  }

  getMyAllProjectScenarioWholesaleListAsync(storagetypeId: any, scenarioId: any, projectId: any) {
    return this.http
      .get<any>(
        `${this.apiUrl}/Storage/GetAllStorageListByTypeAndScenarioId?storagetypeId=${storagetypeId}&scenarioId=${scenarioId}&projectId=${projectId}`
      )
      .toPromise();
  }

  addUpdateProjectScenario(payload: any) {
    return this.http.post<any>(`${this.apiUrl}/Scenario/AddUpdateScenario`, payload);
  }

  deleteProjectScenarioData(scenarioId: any) {
    return this.http.delete<any>(`${this.apiUrl}/Scenario/DeleteScenario?scenarioId=${scenarioId}`);
  }

  copyProjectScenario(scenarioId: any) {
    return this.http
      .get<any>(`${this.apiUrl}/Scenario/GetScenarioForCopy?scenarioId=${scenarioId}`)
      .toPromise();
  }

  saveCopiedProjectScenario(payload: any) {
    return this.http.post<any>(`${this.apiUrl}/Scenario/SaveCopiedScenario`, payload);
  }

  getProjectScenarioConfiguration(scenarioId: any, projectId: any, type: any) {
    return this.http
      .get<any>(
        `${this.apiUrl}/Scenario/GetPackageSenarioDetail?scenarioId=${scenarioId}&projectId=${projectId}&type=${type}`
      )
      .toPromise();
  }

  getScenarioDataForImportProject() {
    return this.http
      .get<any>(`${this.apiUrl}/ImportProject/GetScenarioForImportProject`)
      .toPromise();
  }

  updateProjectScenarioConfiguration(scenarioId: any, column: any, value: any, isDeleteSKU?: any) {
    return this.http
      .post<any>(
        `${this.apiUrl}/Scenario/UpdatePackageConfiguration?scenarioId=${scenarioId}&Column=${column}&Value=${value}&isDeleteSKudata=${isDeleteSKU}`,
        scenarioId
      )
      .toPromise();
  }

  updateScenarioConfigurationImage(payload: any) {
    return this.http
      .post<any>(`${this.apiUrl}/Scenario/UpdatePackageConfigurationImage`, payload)
      .toPromise();
  }

  updateProductConfigurationImage(payload: any) {
    return this.http
      .post<any>(`${this.apiUrl}/ProductContent/UpdateProductConfigurationImage`, payload)
      .toPromise();
  }

  getProjectScopeByIdPresets(scopePresets: any, projectId: any) {
    return this.http.get<any>(
      `${this.apiUrl}/Project/GetProjectScopeIdsByScopePresets?scopePresets=${scopePresets}&projectId=${projectId}`
    );
  }

  getProjectDetailSideMenu(projectId: any) {
    return this.http.get<any>(
      `${this.apiUrl}/Project/GetProjectDetailSideMenu?projectId=${projectId}`
    );
  }

  //pack material
  getMyAllProjectPackMaterialList(scenarioId: any) {
    return this.http.get<any>(
      `${this.apiUrl}/Component/GetAllComponentList?scenarioId=${scenarioId}`
    );
  }

  getEOLComponentList(scenarioId: any) {
    return this.http.get<any>(
      `${this.apiUrl}/Component/GetEOLComponentList?scenarioId=${scenarioId}`
    );
  }

  deleteProjectPackMaterialList(id: any) {
    return this.http.delete<any>(`${this.apiUrl}/Component/DeleteComponent?id=${id}`);
  }
  getAddEditPackMaterialModal(scenarioId: any, id: any, isMaterial: boolean) {
    return this.http.get<any>(
      `${this.apiUrl}/Component/GetComponentForAddUpdate?scenarioId=${scenarioId}&id=${id}&isMaterial=${isMaterial}`
    );
  }

  getAddEditPackMaterialModalAsync(scenarioId: any, id: any, isMaterial: boolean) {
    return this.http
      .get<any>(
        `${this.apiUrl}/Component/GetComponentForAddUpdate?scenarioId=${scenarioId}&id=${id}&isMaterial=${isMaterial}`
      )
      .toPromise();
  }

  addEditMyAllProjectPackMaterialData(payload: any) {
    return this.http.post<any>(`${this.apiUrl}/Component/AddEditComponent`, payload);
  }

  copyProjectPackMaterial(scenarioId: any, payload: any) {
    return this.http.post<any>(
      `${this.apiUrl}/Component/SaveCloneComponent?scenarioId=${scenarioId}`,
      payload
    );
  }
  //refresh pack material
  getCustomMaterialList() {
    const organizationId = this.cookieService.get('organizationId');
    return this.http.get<any>(
      `${this.apiUrl}/Component/GetCustomMaterialList?organizationId=${organizationId}`
    );
  }
  getCustomConversionProcessList() {
    const organizationId = this.cookieService.get('organizationId');
    return this.http.get<any>(
      `${this.apiUrl}/Component/GetCustomConversionProcessList?organizationId=${organizationId}`
    );
  }
  getCustomTruckList() {
    const organizationId = this.cookieService.get('organizationId');
    return this.http.get<any>(
      `${this.apiUrl}/Component/GetCustomTruckList?organizationId=${organizationId}`
    );
  }

  getCustomFillingList() {
    const organizationId = this.cookieService.get('organizationId');
    return this.http.get<any>(
      `${this.apiUrl}/FillingData/GetCustomeFilling?organizationId=${organizationId}`
    );
  }

  getCustomReuseList() {
    const organizationId = this.cookieService.get('organizationId');
    return this.http.get<any>(
      `${this.apiUrl}/ReuseFillingComponentDetail/GetCustomReuses?organizationId=${organizationId}`
    );
  }

  //get custom transport
  GetCustomSiteTransportList(id: any) {
    return this.http.get<any>(
      `${this.apiUrl}/ProductContentIngredient/GetCustomSiteTransportList?id=${id}`
    );
  }

  GetCustomTransportList(id: any) {
    return this.http.get<any>(
      `${this.apiUrl}/ProductContentIngredient/GetCustomTransportList?id=${id}`
    );
  }
  packMaterialInfo(materialId: any, countryId: any, customMaterialId: any, regionId: any) {
    return this.http.get<any>(
      `${this.apiUrl}/Material/GetMaterialInfo?materialId=${materialId}&countryId=${countryId}&customMaterialId=${customMaterialId}&regionId=${regionId}`
    );
  }

  // get pack conversion list
  getMyAllProjectPackConversionList(scenarioId: any, projectId: any) {
    return this.http
      .get<any>(
        `${this.apiUrl}/Component/GetAllConversionsList?scenarioId=${scenarioId}&projectId=${projectId}`
      )
      .toPromise();
  }

  getProjectFillingList(scenarioId: any, projectId: any) {
    return this.http.get<any>(
      `${this.apiUrl}/FillingData/GetAllFillingDataList?scenarioId=${scenarioId}&projectId=${projectId}`
    );
  }

  getProjectFillingListAsync(scenarioId: any, projectId: any) {
    return this.http
      .get<any>(
        `${this.apiUrl}/FillingData/GetAllFillingDataList?scenarioId=${scenarioId}&projectId=${projectId}`
      )
      .toPromise();
  }

  getProjectFillingAddUpdateData(scenarioId: any, id: any) {
    return this.http.get<any>(
      `${this.apiUrl}/FillingData/GetFillingDataForAddUpdate?scenarioId=${scenarioId}&id=${id}`
    );
  }

  getProjectFillingAddUpdateAsync(scenarioId: any, id: any) {
    return this.http
      .get<any>(
        `${this.apiUrl}/FillingData/GetFillingDataForAddUpdate?scenarioId=${scenarioId}&id=${id}`
      )
      .toPromise();
  }

  //pack retail
  getMyAllProjectScenarioRetailList(storagetypeId: any, scenarioId: any, projectId: any) {
    return this.http.get<any>(
      `${this.apiUrl}/Retail/GetAllRetailListByTypeAndScenarioId?storagetypeId=${storagetypeId}&scenarioId=${scenarioId}&projectId=${projectId}`
    );
  }

  getMyAllProjectScenarioRetailListAsync(storagetypeId: any, scenarioId: any, projectId: any) {
    return this.http
      .get<any>(
        `${this.apiUrl}/Retail/GetAllRetailListByTypeAndScenarioId?storagetypeId=${storagetypeId}&scenarioId=${scenarioId}&projectId=${projectId}`
      )
      .toPromise();
  }
  getAddEditPackRetailModal(scenarioId: any, id: any, storageTypeId: any) {
    return this.http.get<any>(
      `${this.apiUrl}/Retail/GetRetailForAddUpdate?scenarioId=${scenarioId}&id=${id}&storageTypeId=${storageTypeId}`
    );
  }

  getAddEditPackRetailModalAsync(scenarioId: any, id: any, storageTypeId: any) {
    return this.http
      .get<any>(
        `${this.apiUrl}/Retail/GetRetailForAddUpdate?scenarioId=${scenarioId}&id=${id}&storageTypeId=${storageTypeId}`
      )
      .toPromise();
  }

  getEolLifeList(
    storageId: any,
    packagescenarioId: any,
    countryId: any,
    customWasteScenarioId: any,
    storageTypeId: any,
    isCreate: any
  ) {
    return this.http.get<any>(
      `${this.apiUrl}/Retail/EndofLifeList?storageId=${storageId}&packagescenarioId=${packagescenarioId}&countryId=${countryId}&customWasteScenarioId=${customWasteScenarioId}&storageTypeId=${storageTypeId}&isCreate=${isCreate}`
    );
  }

  getEolLifeListAsync(
    storageId: any,
    packagescenarioId: any,
    countryId: any,
    customWasteScenarioId: any,
    storageTypeId: any,
    isCreate: any,
    EOLEntrySource: any
  ) {
    return this.http
      .get<any>(
        `${this.apiUrl}/Retail/EndofLifeList?storageId=${storageId}&packagescenarioId=${packagescenarioId}&countryId=${countryId}&customWasteScenarioId=${customWasteScenarioId}&storageTypeId=${storageTypeId}&isCreate=${isCreate}&EOLSourceType=${EOLEntrySource}`
      )
      .toPromise();
  }

  addEditMyAllProjectPackRetailData(payload: any) {
    return this.http.post<any>(`${this.apiUrl}/Retail/AddUpdateRetail`, payload);
  }

  deleteProjectPackRetailList(storageId: any) {
    return this.http.delete<any>(`${this.apiUrl}/Retail/DeleteRetail?storageId=${storageId}`);
  }

  addUpdateProjectFilling(payload: any) {
    return this.http.post<any>(`${this.apiUrl}/FillingData/AddUpdateFillingData`, payload);
  }

  deleteProjectFilling(fillingProcessId: any, fillingId: any) {
    return this.http.delete<any>(
      `${this.apiUrl}/FillingData/DeleteFillingProcess?fillingProcessId=${fillingProcessId}&fillingId=${fillingId}`
    );
  }

  // pack consumer
  getMyAllProjectScenarioConsumerList(storagetypeId: any, scenarioId: any, projectId: any) {
    return this.http.get<any>(
      `${this.apiUrl}/Consumer/GetAllConsumerListByTypeAndScenarioId?storagetypeId=${storagetypeId}&scenarioId=${scenarioId}&projectId=${projectId}`
    );
  }

  getMyAllProjectScenarioConsumerListAsync(storagetypeId: any, scenarioId: any, projectId: any) {
    return this.http
      .get<any>(
        `${this.apiUrl}/Consumer/GetAllConsumerListByTypeAndScenarioId?storagetypeId=${storagetypeId}&scenarioId=${scenarioId}&projectId=${projectId}`
      )
      .toPromise();
  }

  openAddEditModalDataForProjectScenarioConsumer(scenarioId: any, id: any, storageTypeId: any) {
    return this.http.get<any>(
      `${this.apiUrl}/Consumer/GetConsumerForAddUpdate?scenarioId=${scenarioId}&id=${id}&storageTypeId=${storageTypeId}`
    );
  }

  openAddEditModalDataForProjectScenarioConsumerAsync(
    scenarioId: any,
    id: any,
    storageTypeId: any
  ) {
    return this.http
      .get<any>(
        `${this.apiUrl}/Consumer/GetConsumerForAddUpdate?scenarioId=${scenarioId}&id=${id}&storageTypeId=${storageTypeId}`
      )
      .toPromise();
  }
  addEditMyAllProjectPackConsumerData(payload: any) {
    return this.http.post<any>(`${this.apiUrl}/Consumer/AddUpdateConsumer`, payload);
  }
  deleteProjectPackConsumerList(storageId: any) {
    return this.http.delete<any>(`${this.apiUrl}/Consumer/DeleteConsumer?storageId=${storageId}`);
  }

  // Chart at a glance
  getChartAtAGlanceData(projectId: any) {
    return this.http
      .get<any>(`${this.apiUrl}/Report/GetGlanceReportFormData?projectId=${projectId}`)
      .toPromise();
  }

  /**
   * Everything the chart at a glance form needs in one round trip — scenarios,
   * chart types with their nested comparisons / impact categories, indicators,
   * functional units, saved defaults and the two validation banners. Replaces
   * `GetGlanceReportFormData` + `GetChartTypeOptionsProjectReport`.
   */
  getChartReportFormData(projectId: any) {
    return this.http
      .get<any>(`${this.apiUrl}/Report/GetChartReportFormData?projectId=${projectId}`)
      .toPromise();
  }

  getProjectWholesaleAddUpdateData(scenarioId: any, id: any, storageTypeId: any) {
    return this.http.get<any>(
      `${this.apiUrl}/Storage/GetStorageForAddUpdate?scenarioId=${scenarioId}&id=${id}&storageTypeId=${storageTypeId}`
    );
  }

  getProjectWholesaleAddUpdateAsync(scenarioId: any, id: any, storageTypeId: any) {
    return this.http
      .get<any>(
        `${this.apiUrl}/Storage/GetStorageForAddUpdate?scenarioId=${scenarioId}&id=${id}&storageTypeId=${storageTypeId}`
      )
      .toPromise();
  }

  getLoadPerPallet(scenarioId: any, projectId: any) {
    return this.http.get<any>(
      `${this.apiUrl}/Storage/GetLoadPerPallet?scenarioId=${scenarioId}&projectId=${projectId}`
    );
  }

  getTruckMassLoad(customtruckId: any) {
    return this.http.get<any>(
      `${this.apiUrl}/Storage/GetTruckMassLoad?customtruckId=${customtruckId}`
    );
  }

  addUpdateProjectWholesale(payload: any) {
    return this.http.post<any>(`${this.apiUrl}/Storage/AddUpdateStorage`, payload);
  }

  deleteProjectWholesale(id: any) {
    return this.http.delete<any>(`${this.apiUrl}/Storage/DeleteStorage?storageId=${id}`);
  }

  getPackRetailCustomTruckList() {
    const organizationId = this.cookieService.get('organizationId');
    return this.http.get<any>(
      `${this.apiUrl}/Retail/GetCustomTrucks?organizationId=${organizationId}`
    );
  }
  getCustomStorageList() {
    return this.http.get<any>(`${this.apiUrl}/CustomStorage/GetCustomStorageLookUpList`);
  }

  disableFilling(isExclude: any, scenarioId: any) {
    return this.http.post<any>(
      `${this.apiUrl}/FillingData/ExcludeFillingData?isExclude=${isExclude}&scenarioId=${scenarioId}`,
      {}
    );
  }

  disableWholesale(isExclude: any, scenarioId: any) {
    return this.http.get<any>(
      `${this.apiUrl}/Storage/ExcludeWholesale?isExclude=${isExclude}&scenarioId=${scenarioId}`,
      {}
    );
  }

  disableAllProjectMenus(isExclude: any, scenarioId: any) {
    return this.http.post<any>(
      `${this.apiUrl}/FillingData/ExcludeAllData?isExclude=${isExclude}&scenarioId=${scenarioId}`,
      {}
    );
  }

  disableRetail(isExclude: any, scenarioId: any) {
    return this.http.get<any>(
      `${this.apiUrl}/Retail/ExcludeRetail?isExclude=${isExclude}&scenarioId=${scenarioId}`,
      {}
    );
  }

  disableConsumer(isExclude: any, scenarioId: any) {
    return this.http.get<any>(
      `${this.apiUrl}/Consumer/ExcludeConsumer?isExclude=${isExclude}&scenarioId=${scenarioId}`,
      {}
    );
  }
  projectRetailAndConsumerInlineEdit(payload: any) {
    return this.http.post<any>(`${this.apiUrl}/Storage/InLineEdit`, payload);
  }
  projectMaterialInlineEdit(payload: any) {
    return this.http.post<any>(`${this.apiUrl}/Component/InLineEdit`, payload);
  }

  updateBookMark(data: any) {
    return this.http.post<any>(
      `${this.apiUrl}/Component/UpdateComponentBookmark?id=${
        data.componentId
      }&isBookmarked=${!data.isBookmarked}`,
      {}
    );
  }

  getBookmarkedComponentList() {
    return this.http.get<any>(`${this.apiUrl}/Component/GetBookmarkedComponentList`);
  }

  projectScenarioNameInlineEdit(payload: any) {
    return this.http.post<any>(`${this.apiUrl}/Scenario/InLineEdit`, payload);
  }

  //project product

  saveProjectProduct(payload: any) {
    return this.http.post<any>(
      `${this.apiUrl}/ProductConfiguration/AddUpdateProductConfiguration`,
      payload
    );
  }

  copyProductConfiguration(payload: any) {
    return this.http.post<any>(
      `${this.apiUrl}/ProductConfiguration/CopyProductConfiguration`,
      payload
    );
  }

  saveSubProjectProduct(payload: any) {
    return this.http.post<any>(`${this.apiUrl}/ProductContent/AddUpdateProductContent`, payload);
  }

  deleteProductProject(productId: any) {
    return this.http.delete<any>(
      `${this.apiUrl}/ProductContent/DeleteProductContent?productId=${productId}`
    );
  }

  deleteProductConfigurationProject(productConfigId: any) {
    return this.http.delete<any>(
      `${this.apiUrl}/ProductConfiguration/DeleteProductConfiguration?productConfigId=${productConfigId}`
    );
  }

  //product ingredient

  getProjectProductIngredient(productId: any, payload: any) {
    return this.http.post<any>(
      `${this.apiUrl}/ProductContentIngredient/GetProductIngredientList?productId=${productId}`,
      payload
    );
  }
  editProjectProductIngredient(payload: any) {
    return this.http.post<any>(
      `${this.apiUrl}/ProductContent/EditProductContentConfigurationData`,
      payload
    );
  }

  openModalProductIngredient(productId: any, id: any) {
    return this.http.get<any>(
      `${this.apiUrl}/ProductContentIngredient/GetProductIngredientDataForAddUpdate?productId=${productId}&id=${id}`
    );
  }

  getUnitForProductIngredient(ingredientId: any) {
    return this.http.get<any>(
      `${this.apiUrl}/ProductContentIngredient/GetUnit?ingredientId=${ingredientId}`
    );
  }

  addEditMyAllProjectProductIngredient(payload: any) {
    return this.http.post<any>(`${this.apiUrl}/ProductContentIngredient/SaveProductData`, payload);
  }
  getCalculationForFilling(amount: any, costperunit: any) {
    return this.http.get<any>(
      `${this.apiUrl}/FillingData/GetCostPerPackage?amount=${amount}&costperunit=${costperunit}`
    );
  }

  editScenarioConfiguration(scenarioId: any, column: any, value: any) {
    return this.http
      .post<any>(
        `${this.apiUrl}/Scenario/EditPackageScenarioConfiguration?scenarioId=${scenarioId}&Column=${column}&Value=${value}`,
        {}
      )
      .toPromise();
  }

  //product manufacture
  getProjectProductManufacture(productId: any) {
    return this.http.get<any>(
      `${this.apiUrl}/ProductContentIngredient/GetManufacturingProcessList?productId=${productId}`
    );
  }

  getProjectEOLConsumer(payload: any, scenarioId: any) {
    return this.http.post<any>(
      `${this.apiUrl}/ReuseFillingComponentDetail/GetPostRetailEndOfLifeList?scenarioId=${scenarioId}`,
      payload
    );
  }

  getProjectEOLConsumerAsync(scenarioId: any) {
    return this.http
      .get<any>(
        `${this.apiUrl}/ReuseFillingComponentDetail/GetAllPostRetailEndOfLifeList?scenarioId=${scenarioId}`
      )
      .toPromise();
  }

  getProjectEOLRetail(payload: any, scenarioId: any) {
    return this.http.post<any>(
      `${this.apiUrl}/ReuseFillingComponentDetail/GetPreRetailEndOfLifeList?scenarioId=${scenarioId}`,
      payload
    );
  }

  getProjectEOLRetailAsync(scenarioId: any) {
    return this.http
      .get<any>(
        `${this.apiUrl}/ReuseFillingComponentDetail/GetAllPreRetailEndOfLifeList?scenarioId=${scenarioId}`
      )
      .toPromise();
  }

  updateNoOfTripsDataEOL(payload: any) {
    return this.http.post<any>(
      `${this.apiUrl}/ReuseFillingComponentDetail/InLineEditReuseData`,
      payload
    );
  }

  openAddEditPreRetail(scenarioId: string, reuseFillingId: string, storagetypeId: number) {
    return this.http.get<any>(
      `${this.apiUrl}/ReuseFillingComponentDetail/GetReuseFillingsForAddEditRetail?scenarioId=${scenarioId}&reuseFillingId=${reuseFillingId}&storagetypeId=${storagetypeId}`
    );
  }

  openAddEditPreRetailForasync(scenarioId: string, reuseFillingId: string, storagetypeId: number) {
    return this.http
      .get<any>(
        `${this.apiUrl}/ReuseFillingComponentDetail/GetReuseFillingsForAddEditRetail?scenarioId=${scenarioId}&reuseFillingId=${reuseFillingId}&storagetypeId=${storagetypeId}`
      )
      .toPromise();
  }

  openAddEditPostRetail(scenarioId: string, reuseFillingId: string, storagetypeId: number) {
    return this.http.get<any>(
      `${this.apiUrl}/ReuseFillingComponentDetail/GetReuseFillingsForAddEditConsumer?scenarioId=${scenarioId}&reuseFillingId=${reuseFillingId}&storagetypeId=${storagetypeId}`
    );
  }

  addEditEolPreRetail(payload: any) {
    return this.http.post<any>(
      `${this.apiUrl}/ReuseFillingComponentDetail/AddUpdateReuseFillingRetail`,
      payload
    );
  }

  addEditEolPostRetail(payload: any) {
    return this.http.post<any>(
      `${this.apiUrl}/ReuseFillingComponentDetail/AddUpdateReuseFillingConsumer`,
      payload
    );
  }

  deleteEolPreRetail(id: any, reuseFillingComponentDetailId: any) {
    return this.http.delete<any>(
      `${this.apiUrl}/ReuseFillingComponentDetail/DeleteReuseFillingData?id=${id}&reuseFillingComponentDetailId=${reuseFillingComponentDetailId}`
    );
  }

  generateBarChart(payload: any) {
    return this.http.post<any>(`${this.apiUrl}/Report/BarChartNew`, payload);
  }
  generateBarChartAsync(payload: any) {
    return this.http.post<any>(`${this.apiUrl}/Report/BarChartNew`, payload).toPromise();
  }

  generateSpiderChart(payload: any) {
    return this.http.post<any>(`${this.apiUrl}/Report/SpiderChartNew`, payload);
  }

  /**
   * Unified replacement for `BarChartNew` + `SpiderChartNew` — one
   * calculation-engine run returns the spider chart, the contribution charts,
   * the packaging gauge and the scenario totals, selected via the `sections`
   * bit flags on the payload. Accepts the same `GetChartViewModel` body the
   * two legacy endpoints took.
   */
  generateChartReport(payload: any) {
    return this.http.post<any>(`${this.apiUrl}/Report/GenerateChartReport`, payload);
  }

  getPackRetailCustomWasteScenarioList() {
    const organizationId = this.cookieService.get('organizationId');
    return this.http.get<any>(
      `${this.apiUrl}/Retail/GetCustomWasteScenarios?organizationId=${organizationId}`
    );
  }

  updateConfigYearForScenario(payload: any) {
    return this.http
      .post<any>(`${this.apiUrl}/ProductPackageScenario/SaveConfigurationYear`, payload)
      .toPromise();
  }

  updateConfigYearForScenarioYear(payload: any) {
    return this.http.post<any>(
      `${this.apiUrl}/ProductPackageScenario/SaveConfigurationYear`,
      payload
    );
  }
  getPalletConfig(id: any, scenarioId: any) {
    return this.http
      .get<any>(
        `${this.apiUrl}/Scenario/GetScenarioPalletConfiguration?Id=${id}&ScenarioId=${scenarioId}`
      )
      .toPromise();
  }

  deleteScenarioPackaginLevelInfo(packagingLevelInfoId: any, scenarioId: any) {
    return this.http.delete<any>(
      `${this.apiUrl}/Scenario/DeleteScenarioPackaginLevelInfo?packagingLevelInfoId=${packagingLevelInfoId}&scenarioId=${scenarioId}`
    );
  }

  updatePalletConfig(payload: any) {
    return this.http.post<any>(
      `${this.apiUrl}/Scenario/AddUpdateScenarioPalletConfiguration`,
      payload
    );
  }

  ingredientInfo(ingredientId: any, countryId: any, regionId: any) {
    return this.http
      .get<any>(
        `${this.apiUrl}/ProductContentIngredient/IngredientInfo?ingredientId=${ingredientId}&countryId=${countryId}&regionId=${regionId}`
      )
      .toPromise();
  }

  GetConversionProcessInfo(
    processId: any,
    countryId: any,
    customConversionProcessId: any,
    isTooltip?: boolean
  ) {
    return this.http
      .get<any>(
        `${this.apiUrl}/Material/GetConversionProcessInfo?processId=${processId}&countryId=${countryId}&customConversionProcessId=${customConversionProcessId}&isTooltip=${isTooltip}`
      )
      .toPromise();
  }

  getConversionProcess(materialId: any, isRecommendedConversionProcess: any) {
    return this.http
      .get<any>(
        `${this.apiUrl}/Component/GetConversionProcess?materialid=${materialId}&isRecommendedConversionProcess=${isRecommendedConversionProcess}`
      )
      .toPromise();
  }

  deleteOrgReportingYearData(id: any) {
    return this.http.delete<any>(`${this.apiUrl}/Scenario/DeleteConfigurationYear?id=${id}`);
  }

  openPackagingContentConfigModal(scenarioId: any) {
    return this.http
      .get<any>(
        `${this.apiUrl}/ProductPackageScenarioDetail/GetproductPackageScenarioDetailForAddUpdate?scenarioId=${scenarioId}`
      )
      .toPromise();
  }

  getPackagingContentDetail(productId: any) {
    return this.http
      .get<any>(
        `${this.apiUrl}/ProductPackageScenarioDetail/GetProductDetail?productId=${productId}`
      )
      .toPromise();
  }

  addEditPackagingContentConfig(payload: any) {
    return this.http.post<any>(
      `${this.apiUrl}/ProductPackageScenarioDetail/AddUpdateAsync`,
      payload
    );
  }

  deletePackagingContentConfigData(id: any) {
    return this.http.delete<any>(
      `${this.apiUrl}/ProductPackageScenarioDetail/DeleteProductPackageScenarioDetail?id=${id}`
    );
  }

  getProductUseImpactListData() {
    return this.http
      .get<any>(`${this.apiUrl}/ProductUseImpact/GetAllProductUseImpactList`)
      .toPromise();
  }

  getProductManufactureImpactListData() {
    return this.http
      .get<any>(`${this.apiUrl}/ProductManufactureImpact/GetAllProductManufactureImpactList`)
      .toPromise();
  }

  getAddEditProductUseImpact(conversionProcessId: any, regionId: any) {
    return this.http
      .get<any>(
        `${this.apiUrl}/ProductUseImpact/GetProductUseImpactForAddUpdate?conversionProcessId=${conversionProcessId}&regionId=${regionId}`
      )
      .toPromise();
  }

  getAddEditProductManufactureImpact(conversionProcessId: any, regionId: any) {
    return this.http
      .get<any>(
        `${this.apiUrl}/ProductManufactureImpact/GetProductManufactureImpactForAddUpdate?conversionProcessId=${conversionProcessId}&regionId=${regionId}`
      )
      .toPromise();
  }

  getRegionListProductUse(conversionProcessId: any) {
    return this.http.get<any>(
      `${this.apiUrl}/ProductUseImpact/GetRegions?conversionProcessId=${conversionProcessId}`
    );
  }

  addUpdateProductUse(payload: any) {
    return this.http.post<any>(
      `${this.apiUrl}/ProductUseImpact/AddUpdateProductUseImpact`,
      payload
    );
  }
  addUpdateProductManufacture(payload: any) {
    return this.http.post<any>(
      `${this.apiUrl}/ProductManufactureImpact/AddUpdateProductManufactureImpact`,
      payload
    );
  }

  deleteProductUse(convertingProcessId: any, regionId: any) {
    return this.http.delete<any>(
      `${this.apiUrl}/ProductUseImpact/DeleteProductUseImpact?convertingProcessId=${convertingProcessId}&regionId=${regionId}`
    );
  }
  deleteProductManufacture(convertingProcessId: any, regionId: any) {
    return this.http.delete<any>(
      `${this.apiUrl}/ProductManufactureImpact/DeleteProductManufactureImpact?convertingProcessId=${convertingProcessId}&regionId=${regionId}`
    );
  }

  getProductSidebarData(productProjectId: any) {
    return this.http.get<any>(
      `${this.apiUrl}/Project/GetProductProjectDetailSideMenu?productConfigId=${productProjectId}`
    );
  }

  updateProjectDisableStatus(projectId: any, isDisabled: boolean) {
    return this.http.get<any>(
      `${this.apiUrl}/Project/UpdateProjectDisableStatus?projectId=${projectId}&isDisabled=${isDisabled}`
    );
  }

  // project configuration
  projectInlineupdatePackagelevels(packagelevelinfoId: any, amount: any, name: any) {
    const payload = {
      packageLevelInFoId: packagelevelinfoId,
      amount: amount,
      packageName: name,
    };
    return this.http.post<any>(`${this.apiUrl}/Project/InlineupdatePackagelevels`, payload);
  }
  getPackagelevelinfoList(scenarioId: any) {
    return this.http.get<any>(
      `${this.apiUrl}/Scenario/GetPackagelevelinfoList?scenarioId=${scenarioId}`
    );
  }

  getProductEOLList(productId: any) {
    return this.http.get<any>(
      `${this.apiUrl}/ProductEndOfLife/GetProductEndOfLifeList?productId=${productId}`
    );
  }

  getProductEOLFormData(productId: any, id: any) {
    return this.http
      .get<any>(
        `${this.apiUrl}/ProductEndOfLife/GetProductEndOfLifeForAddUpdate?productId=${productId}&id=${id}`
      )
      .toPromise();
  }

  getProductAmountOfProductDisposed(productId: any, productDisposalAtEOL: any) {
    return this.http.get<any>(
      `${this.apiUrl}/ProductEndOfLife/GetProductAmountOfProductDisposed?productId=${productId}&productDisposalAtEOL=${productDisposalAtEOL}`
    );
  }

  addEditProductEOL(payload: any) {
    return this.http.post<any>(
      `${this.apiUrl}/ProductEndOfLife/AddUpdateProductEndOfLife`,
      payload
    );
  }

  deleteProductEOL(id: any) {
    return this.http.delete<any>(`${this.apiUrl}/ProductEndOfLife/DeleteProductEndOfLife?id=${id}`);
  }

  getRecycledContentData(materialId: any, countryId: any) {
    return this.http
      .get<any>(
        `${this.apiUrl}/Component/GetMaterialAndRecycleCost?materialid=${materialId}&countryId=${countryId}`
      )
      .toPromise();
  }

  getRegionListForEOL(projectId: any, regionId: any) {
    return this.http
      .get<any>(
        `${this.apiUrl}/City/GetProjectRegionList?projectId=${projectId}&regionId=${regionId}`
      )
      .toPromise();
  }

  removeProjectImage(projectId: any) {
    return this.http.get<any>(`${this.apiUrl}/Project/RemoveProjectImage?projectId=${projectId}`);
  }

  removeScenarioImage(scenarioId: any) {
    return this.http.get<any>(
      `${this.apiUrl}/Project/RemoveScenarioImage?scenarioId=${scenarioId}`
    );
  }

  removeProductImage(productId: any) {
    return this.http.get<any>(
      `${this.apiUrl}/ProductContent/RemoveProductImage?productId=${productId}`
    );
  }

  removeProductConfigurationImage(productConfigId: any) {
    return this.http.get<any>(
      `${this.apiUrl}/ProductConfiguration/RemoveProductConfigImage?productConfigId=${productConfigId}`
    );
  }

  updatePackageEOLRetail(data: any) {
    return this.http.post<any>(`${this.apiUrl}/Retail/AddUpdateEOLValues`, data);
  }

  getProductLossBasedOnSector(scenarioId: number) {
    return this.http.get<any>(
      `${this.apiUrl}/Scenario/GetProductLossBasedOnSector?packageScenarioId=${scenarioId}`
    );
  }

  updateProductLossBasedOnSector(data: any) {
    return this.http.post<any>(`${this.apiUrl}/Scenario/SaveProductLossBasedOnSector`, data);
  }

  getProductDetailsForScenario(scenarioId: number) {
    return this.http.get<any>(
      `${this.apiUrl}/Scenario/GetProductDetailsForScenario?&packageScenarioId=${scenarioId}`
    );
  }

  addUpdatePackageProductAmountDetails(data: any) {
    return this.http.post<any>(
      `${this.apiUrl}/Scenario/AddUpdatePackageProductAmountDetails`,
      data
    );
  }

  addUpdateProductMixItem(data: any) {
    return this.http.post<any>(`${this.apiUrl}/Scenario/AddUpdateProductMixItem`, data);
  }

  deleteProductPackageScenarioDetail(id: any) {
    return this.http.delete<any>(`${this.apiUrl}/Scenario/DeleteProductMixItem?id=${id}`);
  }

  updateScenarioInternalDataConfig(payload: any) {
    return this.http.post<any>(`${this.apiUrl}/Scenario/UpdateScenarioInternalDataConfig`, payload);
  }
  getAllOrganizationConversionProcess() {
    return this.http.get<any>(`${this.apiUrl}/Component/GetAllOrganizationConversionProcess`);
  }

  getComponentList(storagetypeId: any, scenarioId: any) {
    return this.http.get<any>(
      `${this.apiUrl}/ReuseFillingComponentDetail/GetComponentList?scenarioId=${scenarioId}&storagetypeId=${storagetypeId}`
    );
  }

  savePackagingLevel(pkgLevelId: string, scenarioId: number) {
    return this.http.get<any>(
      `${this.apiUrl}/Scenario/SavePackagingLevel?pkgLevelId=${pkgLevelId}&scenarioId=${scenarioId}`
    );
  }

  AddPalletComponentDataAndReuseData(payload: any) {
    return this.http.post<any>(
      `${this.apiUrl}/Scenario/AddPalletComponentDataAndReuseData`,
      payload
    );
  }

  getProductUseDataList(productId: string) {
    return this.http.get<any>(
      `${this.apiUrl}/ProductContentIngredient/GetProductUsesList?productId=${productId}`
    );
  }

  getProductUseModalData(productId: string) {
    return this.http.get<any>(
      `${this.apiUrl}/ProductContentIngredient/GetProductUseProcessDataForAddUpdate?productId=${productId}`
    );
  }

  saveProdUseData(payload: any) {
    return this.http.post<any>(
      `${this.apiUrl}/ProductContentIngredient/SaveProductUseProcessData`,
      payload
    );
  }

  addUpdateScenarioOrder(payload: any) {
    return this.http.post<any>(`${this.apiUrl}/Scenario/AddUpdateScenarioOrder`, payload);
  }

  addUpdateProductOrder(payload: any) {
    return this.http.post<any>(`${this.apiUrl}/ProductContent/AddUpdateProductOrder`, payload);
  }
  copySubProduct(payload: any) {
    return this.http.post<any>(`${this.apiUrl}/ProductContent/SaveCopyProduct`, payload);
  }
  addUpdateMaterialOrder(payload: any) {
    return this.http.post<any>(`${this.apiUrl}/Component/AddUpdateComponentOrder`, payload);
  }

  getAllEolDetails(payload: any) {
    return this.http.get<any>(
      `${this.apiUrl}/Retail/GetEOLDetails?projectId=${payload.projectId}&packageScenarioId=${payload.packageScenarioId}&scenarioId=${payload.scenarioId}`
    );
  }

  updateIncorrectEOLRates(packageScenarioId: any) {
    return this.http.post<any>(
      `${this.apiUrl}/Retail/UpdateIncorrectEOLRates?packageScenarioIds=${packageScenarioId}`,
      {}
    );
  }

  checkProjectCode(projectCode: any) {
    return this.http.get<any>(`${this.apiUrl}/Project/CheckProjectCode?projectCode=${projectCode}`);
  }

  getProductConfigurationDataForCopy(productConfigId: any) {
    return this.http
      .get<any>(
        `${this.apiUrl}/ProductConfiguration/GetProductConfigurationDataforCopy?productConfigId=${productConfigId}`
      )
      .toPromise();
  }

  updateProductEndOfLifeCountry(productConfigId: any, countryId: any) {
    return this.http.get<any>(
      `${this.apiUrl}/ProductEndOfLife/UpdateProductEndOfLifeCountry?productId=${productConfigId}&countryId=${countryId}`
    );
  }
}
